import React from 'react';
import styled from 'styled-components';
import { Modal } from '../../admin/design-system/components/Modal';
import { Button } from '../../admin/design-system/components/Button';

interface ConfirmDialogProps {
  isOpen: boolean;
  title: string;
  message: string;
  confirmText?: string;
  cancelText?: string;
  onConfirm: () => void;
  onCancel: () => void;
  variant?: 'default' | 'destructive';
}

const Message = styled.p`
  font-family: ${props => {
    const theme = props.theme as any;
    if (theme?.typography?.fontFamily) {
      return typeof theme.typography.fontFamily === 'string' 
        ? theme.typography.fontFamily 
        : theme.typography.fontFamily.body || 'Inter, sans-serif';
    }
    return 'Inter, sans-serif';
  }};
  font-size: ${props => {
    const theme = props.theme as any;
    return theme?.typography?.fontSize?.base || theme?.fontSizes?.base || '14px';
  }};
  color: ${props => {
    const theme = props.theme as any;
    return theme?.colors?.textPrimary || theme?.colors?.text?.primary || '#1a1a1a';
  }};
  margin: 0;
  line-height: ${props => {
    const theme = props.theme as any;
    return theme?.typography?.lineHeight?.relaxed || theme?.lineHeights?.relaxed || '1.5';
  }};
`;

export const ConfirmDialog: React.FC<ConfirmDialogProps> = ({
  isOpen,
  title,
  message,
  confirmText = 'Confirm',
  cancelText = 'Cancel',
  onConfirm,
  onCancel,
  variant = 'default',
}) => {
  const footer = (
    <>
      <Button variant="secondary" onClick={onCancel}>
        {cancelText}
      </Button>
      <Button 
        variant={variant === 'destructive' ? 'destructive' : 'primary'} 
        onClick={onConfirm}
      >
        {confirmText}
      </Button>
    </>
  );

  return (
    <Modal
      isOpen={isOpen}
      onClose={onCancel}
      title={title}
      footer={footer}
      size="small"
    >
      <Message>{message}</Message>
    </Modal>
  );
};

